module.exports = __webpack_public_path__ + "img/logoparent.fe0e17a6.svg";